<template>
    <div v-if="loaded">
        <card-header icon="fa-comment-dots" title="Request Changes"/>

        <card-body>
            <card-list>
                <subheader-list-item title="Student" icon="fa-user"/>
                <data-row title="Name">{{ milestone.first_name }} {{ milestone.last_name }}</data-row>
                <data-row title="Course">{{ milestone.course_title }}</data-row>
                <data-row title="Milestone">{{ milestone.milestone_number }} of {{ milestone.total_milestones }}</data-row>

                <subheader-list-item title="Feedback" icon="fa-comment-dots"/>
                <container-list-item>
                    <p class="has-text-grey mb-4">Please provide feedback explaining what changes are needed. The student will receive this feedback via email and can resubmit their reflection.</p>
                    <b-field label="Feedback for Student">
                        <b-input
                            type="textarea"
                            v-model="feedback"
                            placeholder="Please describe what changes are needed..."
                            rows="6"
                        />
                    </b-field>
                </container-list-item>
            </card-list>
        </card-body>

        <card-footer>
            <div class="columns">
                <div class="column">
                    <b-button size="is-small" @click="$closeCard(card)">
                        Cancel
                    </b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-warning"
                        size="is-small"
                        @click="submit"
                        :loading="submitting"
                        :disabled="!feedback.trim()"
                    >
                        <i class="fas fa-paper-plane mr-2"></i>
                        Send Feedback
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";
    import {client as http} from "@/http_client";
    import {mapActions} from "vuex";

    export default {
        components: {DataRow, ContainerListItem, SubheaderListItem, CardList, CardFooter, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                milestone: null,
                loaded: false,
                submitting: false,
                feedback: ''
            };
        },
        methods: {
            ...mapActions(['getMilestonesCount']),
            load() {
                this.$emit('loading', true);
                http.get(`/milestones/${this.props.milestoneId}`, {force: true}).then(response => {
                    this.milestone = response.data;
                    this.loaded = true;
                    this.$emit('loading', false);
                }).catch(err => {
                    console.error('Error loading milestone:', err);
                    this.$emit('loading', false);
                });
            },
            submit() {
                if (!this.feedback.trim()) return;

                this.submitting = true;
                http.post(`/milestones/${this.props.milestoneId}/reject`, {
                    feedback: this.feedback.trim()
                }).then(() => {
                    this.$buefy.toast.open({
                        message: 'Feedback sent to student',
                        type: 'is-success'
                    });
                    this.getMilestonesCount();
                    this.$closeCard(this.card);
                    this.$reloadCard('milestones');
                }).catch(err => {
                    console.error('Error rejecting milestone:', err);
                    this.$buefy.toast.open({
                        message: 'Error sending feedback',
                        type: 'is-danger'
                    });
                }).finally(() => {
                    this.submitting = false;
                });
            }
        },
        mounted() {
            this.load();
        }
    };
</script>
